import { render, staticRenderFns } from "./WarehousesRecyclingList.vue?vue&type=template&id=fda525d6&"
import script from "./WarehousesRecyclingList.vue?vue&type=script&lang=ts&"
export * from "./WarehousesRecyclingList.vue?vue&type=script&lang=ts&"
import style0 from "./WarehousesRecyclingList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports